const automations = [
  {
    id: 1,
    name: 'AI Lead Capture Chatbot',
    description: 'Automatically captures leads from your website 24/7 and qualifies them with AI-powered conversation flows.',
    status: 'available',
    category: 'Lead Generation',
    icon: 'ri-robot-2-line',
    tags: ['AI', 'Chatbot', 'Leads'],
  },
  {
    id: 2,
    name: 'CRM Auto-Sync',
    description: 'Syncs leads, contacts and deals from multiple sources into one central CRM automatically.',
    status: 'available',
    category: 'CRM',
    icon: 'ri-contacts-book-2-line',
    tags: ['CRM', 'Sync', 'Contacts'],
  },
  {
    id: 3,
    name: 'Automated Review Requests',
    description: 'Sends personalised review requests to customers after service completion to boost your Google ratings.',
    status: 'available',
    category: 'Reputation',
    icon: 'ri-star-line',
    tags: ['Reviews', 'Google', 'Reputation'],
  },
  {
    id: 4,
    name: 'WhatsApp Follow-Up Sequences',
    description: 'Automated WhatsApp message sequences for lead nurturing, appointment reminders and follow-ups.',
    status: 'available',
    category: 'Messaging',
    icon: 'ri-whatsapp-line',
    tags: ['WhatsApp', 'Follow-up', 'Messaging'],
  },
  {
    id: 5,
    name: 'Online Booking System',
    description: 'Full AI-powered booking automation with confirmations, reminders and calendar sync.',
    status: 'available',
    category: 'Bookings',
    icon: 'ri-calendar-check-2-line',
    tags: ['Booking', 'Calendar', 'Appointments'],
  },
  {
    id: 6,
    name: 'Email Drip Campaigns',
    description: 'Personalised automated email sequences triggered by customer actions and behaviours.',
    status: 'available',
    category: 'Email',
    icon: 'ri-mail-send-line',
    tags: ['Email', 'Automation', 'Nurture'],
  },
];

const AutomationsSection = () => {
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h2 className="text-white font-bold text-xl">My Automations</h2>
          <p className="text-ea-gray text-sm mt-0.5">Explore and manage your AI automation services</p>
        </div>
        <a
          href="/contact"
          className="px-4 py-2 bg-ea-blue hover:bg-ea-blue-light text-white text-xs font-semibold rounded-lg transition-colors cursor-pointer whitespace-nowrap flex items-center gap-2"
        >
          <i className="ri-add-line"></i>
          Request Custom
        </a>
      </div>

      {/* Status banner */}
      <div className="bg-ea-blue/5 border border-ea-blue/20 rounded-xl p-5 flex items-start gap-4">
        <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-ea-blue/10 border border-ea-blue/20 shrink-0">
          <i className="ri-information-line text-ea-blue text-base"></i>
        </div>
        <div>
          <p className="text-white text-sm font-medium mb-1">Your Automation Suite</p>
          <p className="text-ea-gray text-xs leading-relaxed">
            These are the available automation services from Everything Automation. Active automations will be configured and managed by our team. Contact us to get started with any service below.
          </p>
        </div>
      </div>

      {/* Automation grid */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        {automations.map((auto) => (
          <div
            key={auto.id}
            className="bg-ea-dark-card border border-ea-dark-border hover:border-ea-blue/30 rounded-xl p-5 transition-all duration-200 group"
          >
            <div className="flex items-start gap-4 mb-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-ea-blue/10 border border-ea-blue/20 shrink-0">
                <i className={`${auto.icon} text-ea-blue text-base`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <h3 className="text-white text-sm font-semibold">{auto.name}</h3>
                  <span className={`px-2 py-0.5 rounded-full text-[10px] font-semibold ${
                    auto.status === 'available'
                      ? 'bg-green-500/10 border border-green-500/20 text-green-400'
                      : 'bg-amber-400/10 border border-amber-400/20 text-amber-400'
                  }`}>
                    {auto.status === 'available' ? 'Available' : 'Coming Soon'}
                  </span>
                </div>
                <span className="text-ea-gray/50 text-[10px] uppercase tracking-wider">{auto.category}</span>
              </div>
            </div>
            <p className="text-ea-gray text-xs leading-relaxed mb-4">{auto.description}</p>
            <div className="flex items-center justify-between">
              <div className="flex gap-1.5 flex-wrap">
                {auto.tags.map((tag) => (
                  <span key={tag} className="px-2 py-0.5 bg-ea-black rounded-md text-ea-gray/60 text-[10px]">{tag}</span>
                ))}
              </div>
              {auto.status === 'available' && (
                <a
                  href="/contact"
                  className="text-ea-blue text-xs font-medium hover:underline cursor-pointer whitespace-nowrap flex items-center gap-1"
                >
                  Get Started
                  <i className="ri-arrow-right-line text-xs"></i>
                </a>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AutomationsSection;
